import { SUBMIT_FORCE_SCAN_REQUEST, SUBMIT_FORCE_SCAN_RESPONSE } from '../constants/action-types'
import { handleResponse } from '../utils/response-utils'
import { getForceScanUrl } from '../utils/url-utils'

export const submitForceScanRequest = () => ({
  type: SUBMIT_FORCE_SCAN_REQUEST
})

export const submitForceScanResponse = (response, error) => ({
  type: SUBMIT_FORCE_SCAN_RESPONSE,
  payload: response,
  error
})

export const submitForceScan = formData => dispatch => {
  dispatch(submitForceScanRequest())
  return fetch(getForceScanUrl(), {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(formData),
    headers: {
      'content-type': 'application/json; charset=UTF-8'
    }
  })
    .then(res => handleResponse(res))
    .then(data => dispatch(submitForceScanResponse(data, false)))
    .catch(error => {
      if (error instanceof TypeError) {
        const error503 = {
          status: 503,
          data: {
            message: 'Service Unavailable'
          }
        }
        dispatch(submitForceScanResponse(error503, true))
      } else {
        dispatch(submitForceScanResponse(error, true))
      }
    })
}



// WEBPACK FOOTER //
// ./src/actions/force-scan-actions.js